export const OFFICES = [
  {
    name: 'Atlanta Office (HQ)',
    address: `3017 Bolling Way NE,
Floor 2,
Atlanta, Georgia, 30305`,
    location: {
      lat: 33.837684,
      long: -84.380209,
    },
  },
  {
    name: 'Malta Office',
    address: `Level 1,
Tagliaferro Business Centre,
High Street, Sliema,
SLM 1551, Malta`,
    location: {
      lat: 35.910644,
      long: 14.506016,
    },
  },
  {
    name: 'Rwanda Office',
    address: `Westerwelle Startup Haus Fl. 4,
Fairview Building,
KG622 Street, Rugando,
Kigali, Rwanda`,
    location: {
      lat: -1.9552914,
      long: 30.0965273,
    },
  },
  {
    name: 'Copenhagen Office',
    address: `c/o Copenhagen Fintech
Applebys Plads 7
1411 København K`,
    location: {
      lat: 55.67218,
      long: 12.57868,
    },
  },
  {
    name: 'UK Subsidiary',
    address: 'Biometric Innovations Ltd',
    location: {
      lat: 51.902676,
      long: -2.076349,
    },
  },
  {
    name: 'Japan Office',
    address: `Otemachi
Building 4f,
1-6-1 Otemachi,
Chiyoda-ku, Tokyo, 100-0004 Japan`,
    location: {
      lat: 35.68572,
      long: 139.765978,
    },
  },
];
